// Uses W3C's official email regex (the same used when validating type="email" on an input)
// https://www.w3.org/TR/2012/WD-html-markup-20120320/input.email.html
// email@domain regex explained
//  - email accepts 1-64 characters in length. Options are a-z, A-Z, 0-9 & specified symbols
//  - domain follows word.repeat format, where ".repeat" must occur at least once
//  - domain <= 255 length is checked at validateEmail
const emailRegexToEndAll = /^[\w.!#$%&’*+/=?^`{|}~-]{1,64}@[\w-]+((?:\.[\w-]+))+$/;

// source: https://stackoverflow.com/a/16699507
const phoneRegex = /^(\+\d{1,2}\s)?\(?\d{3}\)?[\s.-]?\d{3}[\s.-]?\d{4}$/;

export const validateEmail = email => {
  if (!email) return false;

  const domain = email.substring(email.lastIndexOf('@') + 1);

  if (email.length > 256 || domain.length > 254) {
    return false;
  }
  return emailRegexToEndAll.test(email);
};

export const validatePhone = phone => {
  return phoneRegex.test(phone);
};

export const validateNumber = number => {
  if (typeof number !== 'string' && typeof number !== 'number') return false;
  return !isNaN(number);
};
